export default __webpack_public_path__ + "app/images/btn-toolbar-rotate-left-normal.svg";